<template>
    <v-app>    
        <v-main>
            <div class="page">
                <div class="bg-texture"></div>
                <div class="glow"></div>

                <v-card class="login-card" >
                     <div class="d-flex justify-center mb-2">
                        <v-img
                            src="@/assets/logo.png"
                            alt="School Logo"
                            width="120"
                            contain
                            class="flex-grow-0"
                        />
                    </div>

                    <div class="eyebrow">{{ schoolName }}</div>
                    <h1 class="title">Student Portal</h1>

                    <v-alert :type="alert.type" v-if="alert.show">
                        {{ alert.message }}
                    </v-alert>
                    
                    <v-form 
                        class="pa-5"
                        @submit.prevent
                    >
                        <v-text-field
                            label="Student ID"
                            placeholder="Enter student ID"
                            name="id"                                                
                            type="text"
                            color="primary"
                            v-model="formData.student_id"
                            clearable
                            autofocus
                            v-on:keyup="nextStep"
                            outlined
                            dense
                            prepend-inner-icon="mdi-account"
                            class="mb-4"
                        >
                        </v-text-field>                                                
                        
                        <v-text-field
                            v-show="password"
                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show ? 'text' : 'password'"
                            :label="passwordLabel"
                            :placeholder="passwordPlaceholder"
                            :hint="passwordHint"
                            persistent-hint
                            @click:append="show = !show"                                                    
                            name="password"
                            v-model="formData.password"
                            clearable
                            autofocus
                            outlined
                            dense
                            prepend-inner-icon="mdi-key"
                            class="mb-4"
                        >
                        </v-text-field>
                    
                
                        <div class="text-right mt-1  mb-4">                                                
                            <v-btn color="primary" @click="submit" rounded dark block>LOGIN</v-btn>
                        </div>
                    </v-form>

                    <v-overlay
                        :value="getOverlay"
                        opacity="0.8"
                        z-index="10"                    
                    >
                        
                        <v-progress-circular
                            indeterminate
                            size="64"
                        ></v-progress-circular>                   
                    </v-overlay>
                </v-card>
            </div>
                           
        </v-main>
        
    </v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    name: 'Login',
    components: {
        //
    },
    data(){
        return {
            step: 1,
            show: false,
            userpassword: '',
            formData: {
                student_id: '',
                password: '',
                newPassword: '',
                confirmPassword: '',
                changedPassword: '',
            },
            password: true,
            studentIdQuery: false,
            passwordPlaceholder: '',
            passwordLabel: 'Birth Certificate Pin',
            passwordHint: '',
            windowTitle: 'Enter Password',
            resetPasswordErrors: '',
            alert:{
                show: false,
                message: '',
                type: 'error'
            },                      
        }
    },         
    props: {
        source: String,
    },
    watch: {
        userpassword: {
            handler(val){
                this.formData.student_id = val;                
            }
        },              
    },
    computed: {
        ...mapGetters({
            getOverlay: 'auth/getOverlay',
            schoolName: 'form/getSchoolName',            
            getloginErrors: 'auth/getLoginErrors',
            getAuthenticated: 'auth/getAuthenticated',
            getResetPassword: 'auth/getResetPassword',
            validStudentID: 'auth/getStudentIDValidation',            
        }),       
        
    },
    methods: {
        ...mapActions({
            signIn: 'auth/signIn',
            user: 'auth/user',
        }),
        ...mapMutations({
            openDialog: 'auth/setDialog',
            setNewPassword: 'auth/setNewPassword',
            setUserId: 'auth/setUserId',
            setOverlay: 'auth/setOverlay',
        }),
        nextStep(e){
            if(e.keyCode === 13){
                //
            }
        },

        async submit () {
            await this.signIn(this.formData);
            
            if(this.getAuthenticated){
                this.$router.replace('/term-report');
            }
            else{
                this.loginErrors = this.getLoginErrors 
            } 
            this.setOverlay(false);                                              
        },
        
        
    }
}
</script>

<style scoped>
    .page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  position: relative;
  overflow: hidden;
  background: #faf6ef;
}

/* background pattern */
.bg-texture {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(circle, rgba(27,33,66,0.05) 1px, transparent 1px);
  background-size: 28px 28px;
  opacity: 0.6;
}

/* glow effect */
.glow {
  position: absolute;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(201,152,47,0.18), transparent 70%);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* card */
.login-card {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 420px;
  padding: 40px;
  border-radius: 24px;
  border: 1px solid rgba(27,33,66,0.06);
}

/* logo */
.logo-wrap {
  text-align: center;
  margin-bottom: 24px;
}

/* small heading */
.eyebrow {
  text-align: center;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.25em;
  color: #716c62;
  margin-bottom: 8px;
}

/* title */
.title {
  text-align: center;
  margin: 0 0 32px;
  font-family: 'Fraunces', serif;
  font-size: 34px;
  color: #1B2142;
}


/* button */
.login-btn {
  background: linear-gradient(135deg, var(--v-primary-base), var(--v-primary-lighten1));
  color: white;
  font-weight: 600;
  border-radius: 14px;
}

/* back link */
.back-link {
  display: block;
  text-align: center;
  margin-top: 20px;
  color: #2C3568;
  text-decoration: none;
  font-size: 14px;
} 

</style>